import ItemsLeftAtClient from './ItemsLeftAtClient';

export default ItemsLeftAtClient;